import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { useTableContext } from "./table.context"

export type TableCountProps = ComponentProps<"div">

/**
 * "Showing X of Y" for every table, rendered inline at the toolbar's right
 * edge: X is what the operator actually sees (after client-side filters),
 * Y the best-known maximum — the server's matching total when the table is
 * server-paginated (synced up from Table.Content), otherwise everything
 * loaded.
 */
function TableCount(props: TableCountProps) {
  const { className, ...divProps } = props
  const { table, countMeta } = useTableContext()

  const shown = table.getFilteredRowModel().rows.length
  const loaded = table.getCoreRowModel().rows.length
  const total = countMeta.total ?? loaded

  return (
    <div className={cn("ui-table-count", className)} {...divProps}>
      {`Showing ${shown} of ${total} ${countMeta.label}`}
    </div>
  )
}

export default TableCount
